import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

    complemento_storeIdComplemento({commit, dispatch}, form) {
        return new Promise((resolve, reject) => {

            axios.post(Config.apiPath + 'complemento/store-id-complemento', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    complemento_getIdComplemento() {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'complemento/list-id-complemento')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {};

export default {
    state,
    actions,
    mutations
};